import { BlockModule } from '@/website/blocks/common'
import PublicUrlShortenerForm from './components/PublicUrlShortenerForm.vue'
import PublicUrlShortenerLinksList from './components/PublicUrlShortenerLinksList.vue'

new BlockModule({
    selector: '.block-public-url-shortener',
    vueComponent: PublicUrlShortenerForm,
})

new BlockModule({
    selector: '.block-public-url-shortener-link-list',
    vueComponent: PublicUrlShortenerLinksList,
})
